import { getObjectsSum } from '../../../utils/common'
import { BAR_CHART_X_AXIS_DEFAULT_PROPS } from '../../Chart'

// A bucket also carries the count of itself and every older one ("stuck 30+
// days"); on the oldest bucket that would only repeat its own value.
export function getBirdviewAgingChartItems(items) {
  return items.map((item, index) => ({
    ...item,
    ...(index < items.length - 1
      ? { cumulative: getObjectsSum(items.slice(index)) }
      : null),
  }))
}

export function getBirdviewAgingChartLegendItems(items) {
  return items.map(({ color, id, label }) => ({ color, id, label }))
}

// The axis shows the counts; the bucket names live in the legend.
export function getBirdviewAgingChartXAxisProps(items) {
  return {
    ...BAR_CHART_X_AXIS_DEFAULT_PROPS,
    tickFormatter: (_, index) => items[index]?.value,
  }
}
